import { Link } from 'react-router-dom';
import { mangas } from '@/mocks/manga';

export default function LatestUpdates() {
  const sorted = [...mangas].sort(
    (a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime()
  );
  const latest = sorted.slice(0, 8);

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
              最近更新
            </span>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
              最新漫画更新
            </h2>
            <p className="text-sm text-foreground-600 mt-2">
              实时更新刃牙漫画最新章节，不错过每一话精彩内容
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {latest.map((manga) => {
            const latestChapter = manga.chapters[0];
            return (
              <div
                key={manga.slug}
                className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300"
              >
                <Link to={`/article/${manga.slug}`} className="flex gap-4 p-4">
                  <div className="w-20 h-28 flex-shrink-0 rounded-md overflow-hidden bg-background-200">
                    <img
                      src={manga.coverImage}
                      alt={manga.title}
                      title={`${manga.title} - 刃牙漫画在线观看`}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="flex-1 min-w-0 flex flex-col justify-between">
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                        {manga.title}
                      </h3>
                      <p className="text-xs text-foreground-500 mt-1">
                        {manga.author} · {manga.category}
                      </p>
                    </div>
                    <div>
                      {latestChapter && (
                        <Link
                          to={`/article/${manga.slug}`}
                          className="inline-block text-xs text-primary-600 font-medium hover:text-primary-700 transition-colors mt-1"
                        >
                          最新：{latestChapter.title}
                        </Link>
                      )}
                      <div className="flex items-center gap-2 mt-2">
                        <span className={`px-1.5 py-0.5 rounded text-[10px] font-medium ${
                          manga.status === '连载中'
                            ? 'bg-accent-100 text-accent-700'
                            : 'bg-background-200 text-foreground-600'
                        }`}>
                          {manga.status}
                        </span>
                        <span className="text-[10px] text-foreground-400">
                          更新于 {manga.updateDate}
                        </span>
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}